

import { handleRetrieveForumCategories } from "../../../../redux/public-slices/forum.slice"
import { handleRetrieveBlogCategories } from "../../../../redux/public-slices/blog.slice"
import { Box, Grid2 as Grid, Stack, Typography } from "@mui/material"
import SkeletonImage from "../../../ui/SkeletonImage"
import { useLocation, useNavigate } from "react-router-dom"
import { useState, useEffect, useRef } from "react"
import { useDispatch } from "react-redux"
import Slider from "react-slick"
import Images from "../../../../assets/js/Images"

function CategorySlider({ categoryIcon }) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const slickRef = useRef(null)

  const [data, setData] = useState([])
  const route = pathname?.split("/")?.[1]

  // Handle get all blogs/forums
  const handleRetrieveAll = async () => {
    try {
      let response = null
      if (route === "forum-category" || route === "forum") {
        response = await dispatch(handleRetrieveForumCategories({
          limit: 20
        })).unwrap()
      } else if (route === "blog-category" || route === "blog") {
        response = await dispatch(handleRetrieveBlogCategories({
          limit: 20
        })).unwrap()
      }

      if (response?.records) {
        setData(response.records)
      }
    } catch (error) {
      console.error("Error retrieving categories:", error)
    }
  }

  useEffect(() => {
    handleRetrieveAll()
    // eslint-disable-next-line
  }, [route])

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,

    slidesToShow: 1,
    slidesToScroll: 1,

    speed: 3000,
    autoplaySpeed: 2000,
    cssEase: "linear",

    pauseOnHover: false,
    pauseOnFocus: false,

  }

  const chunkData = (array, chunkSize = 4) => {
    if (array.length === 0) return []

    const chunks = []
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize))
    }

    if (chunks.length === 1) {
      chunks.push([...chunks[0]])
    }

    return chunks
  }

  const chunkedData = chunkData(data, 4)



  useEffect(() => {
    if (slickRef.current && chunkedData.length > 0) {
      setTimeout(() => {
        slickRef.current?.slickGoTo(0)
      }, 100)
    }
  }, [chunkedData.length])

  if (!data || data.length === 0) {
    return (
      <Box p={2}>
        <Typography>No categories available</Typography>
      </Box>
    )
  }



  return (
    <Box sx={{
      '& .slick-slide': { padding: '0 15px' },
      '& .slick-track': { display: 'flex', alignItems: 'center' },
      '& .slick-dots': {
        bottom: '-50px',
        '& li button:before': {
          fontSize: '12px',
          color: '#ccc'
        },
        '& li.slick-active button:before': {
          color: '#1976d2'
        }
      }
    }}>


      <Slider {...settings} ref={slickRef}>
        {chunkedData.map((chunk, slideIndex) => (
          <Box key={slideIndex} px={2}>


            <Grid container spacing={2} sx={{ maxWidth: '600px', mx: 'auto' }}>
              {chunk.map((element, itemIndex) => (
                <Grid key={`${slideIndex}-${element?._id || itemIndex}`} size={{ xs: 6, sm: 6, md: 6 }}>
                  <Stack
                    spacing={1}
                    sx={{
                      p: 2,
                      height: "100%",
                      bgcolor: "white",
                      cursor: "pointer",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      transition: "transform 0.2s ease, box-shadow 0.2s ease",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
                      }
                    }}
                    alignItems="center"
                    onClick={() =>
                      navigate(`/${route?.split("-")?.shift()}-category/${element?._id}`)
                    }
                  >
                    <SkeletonImage
                      sx={{
                        mx: "auto",
                        height: "auto",
                        display: "grid",
                        maxWidth: "80px",
                        aspectRatio: "1/1",
                        borderRadius: "500px",
                        placeContent: "center",
                        boxShadow: "0 0 20px 0 #00000030"
                      }}
                      // src={element.icon}
                      src={Images?.stepIcon3}
                    />
                    <Typography
                      fontSize={14}
                      fontWeight="600"
                      textAlign="center"
                      color="other.color1"
                      flexWrap={"wrap"}
                    >
                      {element?.name}
                    </Typography>
                  </Stack>
                </Grid>
              ))}

            </Grid>
          </Box>
        ))}
      </Slider>
    </Box>
  )
}

export default CategorySlider